<template>
  <q-dialog v-model="dialogAffiliate" persistent>
    <q-card style="min-width: 600px">
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title> {{ $t('history') }} {{ affiliateName }} </q-toolbar-title>

        <q-btn flat round dense icon="mdi-close" @click="onClose" />
      </q-toolbar>

      <q-form @submit.prevent="sendMessage" ref="form">
        <q-card-section>
          <div v-if="!commentaries.length">
            <p class="text-center q-pa-lg text-grey">Não há histórico para este afiliado.</p>
          </div>
          <q-chat-message
            v-for="(comment, index) in commentaries"
            :key="index"
            :name="comment.user_name"
            :text="[comment.text]"
            :sent="comment.user_id === user.user_id"
            :stamp="comment.date"
            :bg-color="
              comment.action_id
                ? editing && editingCommentaryId == comment.id
                  ? 'yellow-4'
                  : 'yellow-2'
                : editing && editingCommentaryId == comment.id
                ? 'grey-4'
                : 'grey-2'
            "
            :text-color="comment.action_id ? 'yellow-10' : 'grey-9'"
          >
            <template v-slot:avatar>
              <q-avatar
                :color="comment.user_id === user.user_id ? 'primary' : 'grey-5'"
                class="q-mx-sm"
                text-color="white"
              >
                {{ comment.user_name.charAt(0) }}
              </q-avatar>
            </template>
            <template
              v-if="comment.user_id === user.user_id && (!editing || editingCommentaryId != comment.id)"
              v-slot:stamp
            >
              <div class="row items-center no-wrap">
                <span class="q-mr-sm">{{ comment.date }}</span>

                <q-btn flat dense size="sm" icon="edit" v-if="!comment.action_id" @click="startEdit(index)" />

                <q-btn
                  flat
                  dense
                  size="sm"
                  icon="delete"
                  v-if="!comment.action_id"
                  color="negative"
                  @click="onDelete(comment.id)"
                />
              </div>
            </template>
          </q-chat-message>

          <q-separator />

          <div class="row items-center q-pa-sm">
            <q-input
              v-model="message"
              dense
              :label="editing ? $t('editing_commentary') : ''"
              lazy-rules="ondemand"
              outlined
              :rules="[isRequired]"
              class="col q-mr-sm"
              @keyup.enter="$refs.form.submit()"
            />

            <q-btn round color="primary" :icon="editing ? 'save' : 'send'" type="submit">
              <q-tooltip>{{ editing ? $t('save_edition') : $t('send_message') }}</q-tooltip>
            </q-btn>

            <q-btn round color="negative" icon="cancel" class="q-ml-sm" v-if="editing" @click="cancelEditing">
              <q-tooltip>{{ $t('cancel_edition') }}</q-tooltip>
            </q-btn>
          </div>
        </q-card-section>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import AffiliateMixin from '../../mixins/AffiliateMixin';
import AffiliateService from '../../services/AffiliateService';

export default {
  name: 'FormHistory',

  mixins: [AffiliateMixin, AffiliateService],

  data() {
    return {
      message: '',
      commentaries: [],
      editing: false,
      editingCommentaryId: null,
      history: false,
      blockHistory: false,
      affiliateName: String
    };
  },

  watch: {
    affiliateSelect() {
      if (this.affiliateSelect !== null) {
        this.onSetup();
      }
    }
  },

  methods: {
    startEdit(index) {
      this.editing = true;
      this.editingCommentaryId = this.commentaries[index].id;
      this.message = this.commentaries[index].text;
    },

    cancelEditing() {
      this.editing = false;
      this.editingCommentaryId = null;
      this.message = '';
    },

    async sendMessage() {
      try {
        this.onLoading(true);

        let successMessage = '';
        if (this.editing) {
          const { status } = await this.updateAffiliateHistoryCommentary(this.editingCommentaryId, this.message);
          if (status == 200) {
            successMessage = 'commentary_updated_successfully';
          }
        } else {
          const { status } = await this.createAffiliateHistoryCommentary({
            user_id: this.user.user_id,
            user_name: this.user.name,
            text: this.message,
            affiliate_id: this.affiliateSelect.id
          });
          if (status == 201) {
            successMessage = 'commentary_created_successfully';
          }
        }
        this.successNotify(this.$t(successMessage));
        this.onSetup();
        this.cancelEditing();
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async onSetup() {
      this.affiliateName = this.affiliateSelect.name;
      this.message = '';

      this.onLoading(true);

      try {
        const { data, status } = await this.getAffiliateHistoryCommentaries(this.affiliateSelect.id);
        if (status === 200) {
          this.commentaries = data.history;
        }
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    onClose() {
      this.commentaries = [];
      this.affiliateName = '';
      this.cancelEditing();
      this.ActionSetDialogAffiliate(false);
    },

    onSave() {
      if (!this.param) this.onDelete();
      else if (this.history) this.onUpdate();
      else this.onCreate();
    },

    async onCreate() {
      this.onLoading(true);
      try {
        const { status } = await this.$http.post(`/v2/redirect`, {
          app: `affiliate`,
          path: '/api/affiliate_history/',
          params: {
            data: {
              affiliate_id: this.affiliateSelect.id,
              history: this.param
            }
          }
        });

        if (status === 201) this.successNotify('Histórico criado com sucesso!');
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
        this.onClose();
      }
    },


    async onUpdate() {
      this.onLoading(true);
      try {
        const { status } = await this.$http.put(`/v2/redirect`, {
          app: `affiliate`,
          path: '/api/affiliate_history/',
          params: {
            data: {
              affiliate_id: this.affiliateSelect.id,
              history: this.param
            }
          }
        });

        if (status === 200) this.successNotify(this.$t('history_updated_successfully'));
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async onDelete(commentaryId) {
      this.onLoading(true);
      try {
        const { status } = await this.deleteAffiliateHistoryCommentary(commentaryId);
        if (status === 200) this.successNotify(this.$t('commentary_deleted_successfully'));
        this.onSetup();
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  }
};
</script>
